import { BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import * as selectors from '../selectors/breakpoint.selectors';

@Injectable({
  providedIn: 'root',
})
export class BreakpointFacadeService extends FacadeService {
  constructor(public override store: Store<BreakpointState>) {
    super(store);
  }

  // OBSERVABLES
  size$ = this.storeSelect(selectors.getScreenSize);

  // OBSERVABLE'S VALUES
  get size() {
    return this.storeSnapshot(this.size$);
  }
}
